export const ACTION = {
  PROMOTE_ADMIN: 'PROMOTE_ADMIN'
}
